define.alias("shared/components/shared/mavely/links/folder", "preview-grid/components/shared/mavely/links/folder");